import { cva } from 'class-variance-authority'

export { default as Tabs } from './Tabs.vue'
export { default as TabsContent } from './TabsContent.vue'
export { default as TabsList } from './TabsList.vue'
export { default as TabsTrigger } from './TabsTrigger.vue'

export const tabsTriggerVariants = cva(
  'tw:inline-flex tw:items-center tw:justify-center tw:whitespace-nowrap tw:p-3 tw:text-base tw:font-medium tw:ring-offset-background tw:transition-all tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:pointer-events-none tw:disabled:opacity-50',
  {
    variants: {
      variant: {
        line: 'tw:top-px tw:mx-4 tw:relative tw:border-b tw:border-transparent tw:data-[state=active]:bg-background tw:data-[state=active]:text-primary tw:data-[state=active]:border-primary',
        fill: 'tw:px-6 tw:top-px tw:relative tw:rounded-t-md tw:border tw:border-transparent tw:border-b-border tw:hover:border-border tw:data-[state=active]:border-border tw:data-[state=active]:border-b-background tw:data-[state=active]:bg-background tw:data-[state=active]:text-primary',
        pill: 'tw:px-6 tw:relative tw:rounded-md tw:hover:text-primary tw:data-[state=active]:bg-primary/10 tw:data-[state=active]:text-primary',
      },
    },
    defaultVariants: {
      variant: 'line',
    },
  },
)
